import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { Paso1pagePage } from './paso1page.page';

const routes: Routes = [
  {
    path: '',
    component: Paso1pagePage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class Paso1pagePageRoutingModule {}
